import type { DemoKey } from '../types';

export const bn: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'গণিত · পরিসংখ্যান',
  'app.title': 'পরিসংখ্যান',
  'panel.experiment': 'দৃশ্য',
  'panel.params': 'প্যারামিটার',

  'exp.survey-explorer.title': 'সমীক্ষা এক্সপ্লোরার',
  'exp.survey-explorer.desc': 'একটি কলাম বাছুন; ডেমো উপযুক্ত সারাংশ বেছে নেয়।',
  'exp.distribution-sculptor.title': 'বণ্টন ভাস্কর',
  'exp.distribution-sculptor.desc': 'বিন্দু টেনে দেখুন পরিসংখ্যান কীভাবে সাড়া দেয়।',
  'exp.two-variable-lab.title': 'দ্বি-চলক ল্যাব',
  'exp.two-variable-lab.desc': 'স্ক্যাটার, ফিট, এবং কারণ-কার্যের প্রশ্ন।',
  'exp.sampling-lab.title': 'নমুনা ল্যাব',
  'exp.sampling-lab.desc': 'কৌশল ও আকার কীভাবে নমুনা গড়কে নাড়ায়।',
  'exp.probability-diagrams.title': 'সম্ভাবনা চিত্র',
  'exp.probability-diagrams.desc': 'যৌগিক ঘটনার ভেন ও বৃক্ষ দৃশ্য।',

  'type.qualitative-nominal.label': 'গুণগত · নামমাত্র',
  'type.qualitative-nominal.def': 'অন্তর্নিহিত ক্রমহীন শ্রেণি।',
  'type.qualitative-ordinal.label': 'গুণগত · ক্রমিক',
  'type.qualitative-ordinal.def': 'অর্থপূর্ণ ক্রমযুক্ত শ্রেণি।',
  'type.qualitative-multi.label': 'গুণগত · বহু-মান',
  'type.qualitative-multi.def': 'প্রতিটি পর্যবেক্ষণে একাধিক ট্যাগ থাকতে পারে।',
  'type.quantitative-discrete.label': 'পরিমাণগত · বিচ্ছিন্ন',
  'type.quantitative-discrete.def': 'নির্দিষ্ট ধাপে আসা সংখ্যা।',
  'type.quantitative-continuous.label': 'পরিমাণগত · অবিচ্ছিন্ন',
  'type.quantitative-continuous.def': 'অবিচ্ছিন্ন স্কেলে মাপা সংখ্যা।',

  'column.name.label': 'ছাত্রের নাম',
  'column.height_cm.label': 'উচ্চতা',
  'column.shoe_size_eu.label': 'জুতার মাপ (EU)',
  'column.study_hours.label': 'পড়াশোনা ঘণ্টা / সপ্তাহ',
  'column.test_score.label': 'পরীক্ষার নম্বর',
  'column.sports_played.label': 'খেলাধুলা',
  'column.eye_color.label': 'চোখের রঙ',
  'column.commute_min.label': 'যাতায়াত',
  'column.grade_year.label': 'শ্রেণি',
  'column.homework_effort.label': 'বাড়ির কাজে চেষ্টা',
  'column.ice-cream-sales.label': 'আইসক্রিম বিক্রি',
  'column.drownings.label': 'ডুবন্ত ঘটনা',
  'column.month.label': 'মাস',
  'column.storks.label': 'সারস',
  'column.births.label': 'জন্ম',
  'column.country_area_km2.label': 'দেশের আয়তন',
  'column.sleep_hours.label': 'ঘুমের ঘণ্টা',
  'column.reaction_ms.label': 'প্রতিক্রিয়া সময়',

  'dataset.master-survey.label': 'ক্লাস সমীক্ষা',
  'dataset.master-survey.desc': '৩০ জন সিমুলেটেড ছাত্র।',
  'dataset.spurious-ice-cream-vs-drownings.label': 'আইসক্রিম বনাম ডুবে যাওয়া',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'দুটোই ঋতুর সাথে ওঠে নামে। ডুবে যাওয়া আইসক্রিম বিক্রির কারণ নয়।',
  'dataset.spurious-storks-vs-births.label': 'সারস বনাম জন্ম',
  'dataset.spurious-storks-vs-births.desc': 'বড় দেশে বেশি সারস ও বেশি জন্ম। পাখি কারণ নয়।',
  'dataset.real-sleep-vs-reaction-time.label': 'ঘুম বনাম প্রতিক্রিয়া',
  'dataset.real-sleep-vs-reaction-time.desc':
    'বেশি ঘুম, দ্রুত প্রতিক্রিয়া। প্রকৃত ঋণাত্মক সম্পর্ক — যুক্তিসঙ্গত প্রক্রিয়া সহ।',

  'tag.football.label': 'ফুটবল',
  'tag.basketball.label': 'বাস্কেটবল',
  'tag.volleyball.label': 'ভলিবল',
  'tag.swimming.label': 'সাঁতার',
  'tag.none.label': 'কিছু না',

  'population.gaussian.label': 'ঘণ্টা বক্ররেখা',
  'population.right-skewed.label': 'ডানে হেলানো',
  'population.bimodal.label': 'দ্বিশীর্ষ (স্তরসহ)',
  'population.uniform.label': 'সুষম',

  'venn.dice-even-or-prime.label': 'ছক্কা: জোড় বা মৌলিক',
  'venn.class-sports-2set.label': 'খেলা (২ সেট)',
  'venn.class-sports-3set.label': 'খেলা (৩ সেট)',
  'venn.custom.label': 'কাস্টম',

  'tree.draw-without-replacement.label': 'প্রতিস্থাপন ছাড়া',
  'tree.custom.label': 'কাস্টম',
  'tree.coin.heads': 'হেড',
  'tree.coin.tails': 'টেইল',
  'tree.draw.start': 'ব্যাগ: ২ লাল, ৩ নীল',
  'tree.draw.red': 'লাল',
  'tree.draw.blue': 'নীল',
  'tree.custom.start': 'শুরু',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'হিস্টোগ্রাম',
  'card.cumulative': 'ক্রমযোজিত ফ্রিকোয়েন্সি',
  'card.box': 'বক্স প্লট',
  'card.summary': '৫-সংখ্যার সারাংশ',
  'card.bar': 'বার চার্ট',
  'card.mode': 'মোড',
  'card.tag-frequency': 'ট্যাগ ফ্রিকোয়েন্সি',
  'card.mode-tag': 'শীর্ষ ট্যাগ',
  'card.empty-no-order': 'প্রযোজ্য নয়',
  'card.empty-multi': 'প্রযোজ্য নয়',
  'card.numberline': 'সংখ্যা রেখা',
  'card.scatter': 'স্ক্যাটার',
  'card.description': 'কী ঘটছে',
  'card.population': 'জনসংখ্যা',
  'card.sampling-distribution': 'নমুনা গড়',
  'card.venn': 'ভেন',
  'card.tree': 'বৃক্ষ',
  'card.probabilities': 'সম্ভাবনা',

  'param.dataset.label': 'ডেটাসেট',
  'param.column.label': 'কলাম',
  'param.bins.label': 'বিন',
  'param.shape.label': 'প্রারম্ভিক আকার',
  'param.show-mean.label': 'গড় দেখান',
  'param.show-median.label': 'মধ্যমা দেখান',
  'param.x-col.label': 'X কলাম',
  'param.y-col.label': 'Y কলাম',
  'param.show-regression.label': 'রিগ্রেশন লাইন',
  'param.show-residuals.label': 'অবশেষ',
  'param.show-confounder.label': 'কনফাউন্ডার দেখান',
  'param.population.label': 'জনসংখ্যা',
  'param.technique.label': 'কৌশল',
  'param.sample-size.label': 'নমুনার আকার',
  'param.stratum.label': 'স্তর',
  'param.bias.label': 'পক্ষপাত',
  'param.mode.label': 'মোড',
  'param.preset.label': 'প্রিসেট',
  'param.universe.label': 'বিশ্বের আকার',
  'param.show-prob.label': 'সম্ভাবনা দেখান',
  'param.treat-as-numeric.label': 'সংখ্যা হিসেবে গণ্য',

  'stat.count': 'গণনা',
  'stat.mean': 'গড়',
  'stat.median': 'মধ্যমা',
  'stat.range': 'পরিসর',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'বহিরাগত',
  'stat.r': 'পিয়ারসন r',
  'stat.r2': 'r²',
  'stat.slope': 'ঢাল',
  'stat.intercept': 'ছেদাংশ',
  'stat.n': 'n',
  'stat.population-mean': 'প্রকৃত গড়',
  'stat.latest-sample-mean': 'নমুনা গড়',
  'stat.sample-mean-spread': 'নমুনা গড়-SD',
  'stat.sample-count': 'নেওয়া নমুনা',
  'outlier.upper': 'উপরের বহিরাগত',
  'outlier.lower': 'নিচের বহিরাগত',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'পুনর্নমুনা',
  'btn.run-100': '১০০ নমুনা নিন',
  'btn.stop': 'থামান',
  'btn.clear-history': 'ইতিহাস মুছুন',

  'explainer.no-order': 'ক্রম নেই → কিউমুলেটিভ নয়, বক্স নয়।',
  'explainer.multi-no-iqr': 'বহু-মান → কোয়ার্টাইল / IQR অসংজ্ঞায়িত।',
  'message.no-data': 'কোনো ডেটা নেই।',
  'message.needs-quartiles': 'কোয়ার্টাইলের জন্য ≥৪ বিন্দু দরকার।',
  'message.x-zero-variance': 'X-এর ভেদাঙ্ক শূন্য — ফিট করার মতো লাইন নেই।',
  'message.n-too-small': 'n খুব ছোট।',
  'message.stratum-clamp': 'স্তরে চাওয়ার চেয়ে কম সারি — সব ব্যবহৃত।',
  'message.siblings-sum-to-one': 'ভাইবোনের যোগফল ১ হতে হবে।',
};
